import { render } from "./mail.vue?vue&type=template&id=ee8ed628&scoped=true"
import script from "./mail.vue?vue&type=script&lang=js"
export * from "./mail.vue?vue&type=script&lang=js"

import "./mail.vue?vue&type=style&index=0&id=ee8ed628&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee8ed628"]])

export default __exports__